var map = {
	"./bootstrap.svg": 66,
	"./css.svg": 67,
	"./cssnext.svg": 68,
	"./frontend.svg": 69,
	"./git.svg": 70,
	"./gulp.svg": 71,
	"./html.svg": 72,
	"./illustrator.svg": 73,
	"./javascript.svg": 74,
	"./logo.svg": 19,
	"./mysql.svg": 75,
	"./node.svg": 76,
	"./photoshop.svg": 77,
	"./php.svg": 78,
	"./react.svg": 79,
	"./sass.svg": 80,
	"./woocommerce.svg": 81,
	"./wordpress-blue.svg": 82,
	"./wordpress.svg": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;